/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-29 17:21:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-10 14:53:17
 */
import {
  Form,
  Col,
  Input,
  Modal,
  Row,
  notification,
  Checkbox,
  Button, message,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react'
import styles from './Payments.module.css'
import { unwrapResult } from '@reduxjs/toolkit'
import { saveTraceCodesAsync } from './TraceCodeInputSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import {
  drugUploadAAsync,
  drugUploadAsync,
  finishPutstorage,
  getTraceableCodeSave,
  multifunctionalUpAccountAsync,
  rectPutstorageAsync,
} from '../../putstorage/putstorageSlice'
import { ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import { getInsuranceToSelfpayAsync } from '../../treatment/editor/recipeEditorSlice'
import { medicalSendHttp, strParse } from '../../../utils/MedicalUtils'
import {
  selectInsuranceItem,
  setInsurance,
} from '../../../layouts/insuranceSlice'
import { serverType } from '../../../services/commodity'
import { selectInsuranceArray, selectTenantAddress, selectTenantAreaCd, selectTenantCategory, selectTenantName, selectUserId, selectUserName } from '../../../app/applicationSlice'
import { getDeliveryList } from '../../delivery/deliverySlice'
import {numberPattern} from "../../../utils/RegExp";
import {before, now, sum} from "lodash";
import {getRecipeList} from "../../PharmacyRetail/PharmacyRetailSlice";
import {RecipeCategory} from "../../../models/recipe";
import {setSmsCountdown} from "../../login/loglinSlice";
import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'
import { insuranceItem } from '../../../models/echart'

interface TraceCodeInputModalProps {
  showCodeInputModal: boolean
  paymentResult: any
  onCancel: () => void
  onOk: () => void
  isShowUpload: boolean
  showUploadBtn?: boolean
  grrkFlag?: boolean
  receiptsId?: any
  beforeCharge?: boolean
  recipeItemId?: any
  storehouseTag?: boolean
  treatId?: any
}

export const TraceCodeInputModal = ({
  showCodeInputModal,
  paymentResult,
  onCancel,
  onOk,
  isShowUpload,
  showUploadBtn = true,
  beforeCharge = false,
  grrkFlag = false,
  recipeItemId,
  receiptsId,
  storehouseTag,
  treatId
}: TraceCodeInputModalProps): ReactElement => {
  const [items, setItems] = useState<any>([])
  const dispatch = useDispatch<RootDispatch>()

  const [messageApi, contextHolder] = message.useMessage()

  const [buttonLoading, setButtonLoading] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)

  const baseData = useSelector(selectInsuranceItem)

  const [trdnFlagJsn, setTrdnFlagJsn] = useState<any>({})

  const [hideNoTraceItems, setHideNoTraceItems] = useState(localStorage.getItem('hideNoTraceItems-check') ? localStorage.getItem('hideNoTraceItems-check') === 'true' ?  true : false : false)

  const [noTraceJsn, setNoTraceJsn] = useState<any>({})

  const userName = useSelector(selectUserName)
  
  const tenantAddress = useSelector(selectTenantAddress)
  
  const tenantAreaCd = useSelector(selectTenantAreaCd)
  
  const tenantName = useSelector(selectTenantName)
  
  const userId = useSelector(selectUserId)

  const cycleCode = sessionStorage.getItem('cycleCode')
  
  const tenantCategory = useSelector(selectTenantCategory)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [errorList,setErrorList] = useState<any>([])
  const inputRefs: any = useRef(items.map(() => []))
  const [form] = Form.useForm()
  const reVali = () =>{
    setCancelLoading(true)
    setTimeout(() => {
      setCancelLoading(false)
    }, 30)
    form.validateFields().then((values) => {
      return;
    }).catch((e)=>{
      return;
    })
  }
  useEffect(() => {
    reVali();
  }, [trdnFlagJsn])
  useEffect(() => {

    if (items) {
      const jsons: any = {}
      items?.map((item: any, itemIndex: number) => {
        {
          [...Array(Math.ceil(grrkFlag ? item?.count : item?.drugCount))].map(
            (_, colIndex) => {
              if (item?.traceCodeList?.[colIndex]) {
                jsons['tradeCode_' + item?.id + '_' + (Number(colIndex) + 1)] =
                  item?.traceCodeList?.[colIndex]
              }
              trdnFlagJsn[item?.id] = item?.trdnFlag
              if (localStorage.getItem('trdnFlag_' + item?.localItemIdFake) === '1'){
                trdnFlagJsn[item?.id] = 1
              }
              noTraceJsn[item?.id] = item?.noTraceFlag
            }
          )
        }
      })
      setTrdnFlagJsn({...trdnFlagJsn})
      if (jsons) {
        form.setFieldsValue({
          ...jsons,
        })
      }
    }
  }, [items])

    useEffect(() => {
      if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
        dispatch(
          setInsurance({
            ...insuranceItem,
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
          })
        )
      } else {
        dispatch(setInsurance({}))
      }
    }, [insuranceItem])

    useEffect(() => {
        if (insuranceArray.length !== 0) {
          setInsuranceItem(insuranceArray[0])
        }
      }, [insuranceArray])

  useEffect(() => {
    // 初始化inputRefs结构
    if (items && items.length > 0) {
      const newInputRefs: any[] = [];
      items.forEach((item: any, itemIndex: number) => {
        const count = grrkFlag ? item?.count : item?.drugCount;
        const colCount = Math.ceil(count);
        
        // 确保inputRefs.current[itemIndex]存在
        if (!newInputRefs[itemIndex]) {
          newInputRefs[itemIndex] = [];
        }
        
        // 初始化每个输入框的引用
        for (let colIndex = 0; colIndex < colCount; colIndex++) {
          newInputRefs[itemIndex][colIndex] = null;
        }
      });
      inputRefs.current = newInputRefs;
    } else {
      inputRefs.current = [];
    }
  }, [items, grrkFlag]);

  useEffect(() => {
    if (showCodeInputModal && items && items.length > 0) {
      // 延迟执行以确保DOM渲染完成
      const focusTimer = setTimeout(() => {
        // 遍历inputRefs.current查找第一个空的输入框
        let foundEmpty = false;
        for (let itemIndex = 0; itemIndex < items.length && !foundEmpty; itemIndex++) {
          const item = items[itemIndex];
          const count = grrkFlag ? item?.count : item?.drugCount;
          
          for (let colIndex = 0; colIndex < Math.ceil(count) && !foundEmpty; colIndex++) {
            const fieldName = `tradeCode_${item?.id}_${colIndex + 1}`;
            const fieldValue = form.getFieldValue(fieldName);
            
            // 如果当前字段为空且输入框引用存在，则聚焦
            if (!fieldValue && inputRefs.current[itemIndex]?.[colIndex]) {
              inputRefs.current[itemIndex][colIndex].focus();
              foundEmpty = true; // 找到第一个空输入框并聚焦后退出
            }
          }
        }
      }, 100); // 100毫秒延迟确保DOM渲染完成
      
      // 清除定时器
      return () => {
        if (focusTimer) {
          clearTimeout(focusTimer);
        }
      };
    }
  }, [showCodeInputModal, items, form, grrkFlag]);

  const handlePressEnter = (itemIndex: any, colIndex: any) => {
    reVali()
    const nextColIndex = colIndex + 1
    // 如果有下一个 Input，则聚焦
    if (inputRefs.current[itemIndex][nextColIndex]) {
      inputRefs.current[itemIndex][nextColIndex].focus()
    } else if (
      inputRefs.current[itemIndex + 1] &&
      inputRefs.current[itemIndex + 1][0]
    ) {
      // 否则如果有下一个 item，则聚焦该 item 的第一个 Input
      inputRefs.current[itemIndex + 1][0].focus()
    }
  }

  useEffect(() => {
    // 药店结算前扫码
    if (beforeCharge) {
      if (showCodeInputModal && paymentResult) {
        setItems(paymentResult)
      } else {
        setItems([])
        inputRefs.current = items?.map((item: any) =>
            Array(item?.count).fill(null)
        )
        form.resetFields()
        setTrdnFlagJsn({})
        setNoTraceJsn({})
      }
      //购入入库追溯码
    }else if (grrkFlag) {
      if (showCodeInputModal && paymentResult) {

        //入库选择账簿单位 拆零标志设置成0
        const paymentResultForRk = paymentResult.map((item: any)=>{
          return {
            ...item,
            splitTag:0
          }
        })

        setItems(paymentResultForRk)
      } else {
        setItems([])
        inputRefs.current = items?.map((item: any) =>
          Array(item?.count).fill(null)
        )
        form.resetFields()
        setTrdnFlagJsn({})
        setNoTraceJsn({})
      }
      //正常门诊扫码
    } else {
      if (showCodeInputModal && paymentResult) {
        const recipeItems = paymentResult?.materials
          ?.map((v: any) => {
            return v?.itemList
          })
          ?.flat(1)
        if (recipeItems) {
          setItems(
            recipeItems?.filter((v: any) => {
              if (
                (v?.state == 3 || v?.state == 5) &&
                (v?.billingCategory == '01' ||
                  v?.billingCategory == '02' ||
                  v?.billingCategory == '17')
              ) {
                return v
              }
            })
          )
        }
      } else {
        setItems([])
        inputRefs.current = items?.map((item: any) =>
          Array(Math.ceil(item?.drugCount)).fill(null)
        )
        form.resetFields()
        setTrdnFlagJsn({})
        setNoTraceJsn({})
      }
    }
  }, [showCodeInputModal, grrkFlag,beforeCharge, paymentResult])


  const checkTraceCode = (isUpload: boolean,isCheck?:any) => {
    if(isCheck == 0){
      saveTraceCodes(isUpload,isCheck);
    }else{
      let wrongCode = "";
      Object.entries(form.getFieldsValue()).forEach(([key, value]:[string,any]) => {
        if(value?.length>0 && ((value?.indexOf("69")==0 || value?.length!=20))){
          wrongCode += value+"；";
        }
      })
      if(wrongCode&&wrongCode.length>0){
        Modal.confirm({
          title: '提示',
          okText: '确认无误，继续',
          content: (
            <p>
              以下追溯码：{wrongCode} 疑似扫错码，请再次确认是否正确。
            </p>
          ),
          onOk: () => {
            saveTraceCodes(isUpload,isCheck);
          },
          onCancel:() =>{
            setButtonLoading(false)
          }
        })
      }else{
        saveTraceCodes(isUpload,isCheck);
      }
    }

  }



  const saveTraceCodes = (isUpload: boolean,isCheck?:any) => {
    const treatmentId = beforeCharge ? treatId:paymentResult.treatmentId
    const paymentId = paymentResult.id
    if (!form.getFieldsValue()) {
      onCancel()
      return
    }
    // 购入入库保存
    if (grrkFlag) {
      const submitParam: any = []
      Object.entries(form.getFieldsValue()).forEach(([key, value]) => {
        // const recipeItemId = key.split('_')[1]
        const oneRow = {
          receiptsItemId: recipeItemId,
          receiptsId: receiptsId,
          traceCode: value,
        }
        submitParam.push(oneRow)
      })
      dispatch(
        getTraceableCodeSave({
          traceCodes: submitParam,
          receiptsId: receiptsId,
          isCheck: isCheck?.toString() || 1
        })
      )
        .then(unwrapResult)
        .then((v: any) => {
          onOk()
          setButtonLoading(false)
        })
        .catch((v:any) => {
          const errorData = v?.message?.split('####')?.[1]
          const errDataMain = errorData ? JSON.parse(errorData) : {}
          if(v?.message.startsWith("追溯码校验异常") || v?.message.startsWith("追溯码重复采集")){
            Modal.confirm({
              title: '',
              icon: <ExclamationCircleOutlined />,
              okText: '确认无误',
              cancelText: '取消',
              content: (
                <div style={{fontWeight:'bold',marginTop:'-20px',fontSize:'16px'}}>
                  {errDataMain?.codeArray?.map((val:any,index?:any)=>{
                  return <div key={index}>{val}</div>
                  })}
                 <div>{errDataMain?.errMsg}</div>
                </div>
              ),
              onOk: (()=>{
                checkTraceCode(isUpload,0)
              }),
              onCancel: (()=>{
                setButtonLoading(false)
              })
            })
          }else{
            onCancel()
            setButtonLoading(false)
          }
        })
    } else {
      const submitParam: any = []
      
      // 首先处理有追溯码的药品（form中已有的字段）
      Object.entries(form.getFieldsValue()).forEach(([key, value]) => {
        const recipeItemId = key.split('_')[1]
        const oneRow = {
          treatmentId: treatmentId,
          paymentId: paymentId,
          recipeItemId: recipeItemId,
          traceCode: value,
          trdnFlag : trdnFlagJsn[recipeItemId] != 1 ? 0 : trdnFlagJsn[recipeItemId],
          noTraceFlag : noTraceJsn[recipeItemId] != 1 ? 0 : noTraceJsn[recipeItemId],
        }
        submitParam.push(oneRow)
      })
      
      // 然后确保所有药品都被提交，包括无码药品
      items?.forEach((item: any) => {
        const recipeItemId = item.id
        // 检查是否已经处理过这个药品
        const alreadyProcessed = submitParam.some((param: any) => param.recipeItemId == recipeItemId)
        
        if (!alreadyProcessed) {
          // 对于没有追溯码字段的药品（无码药品），创建空的追溯码记录
          const oneRow = {
            treatmentId: treatmentId,
            paymentId: paymentId,
            recipeItemId: recipeItemId,
            traceCode: '', // 无码药品追溯码为空
            trdnFlag : trdnFlagJsn[recipeItemId] != 1 ? 0 : trdnFlagJsn[recipeItemId],
            noTraceFlag : noTraceJsn[recipeItemId] != 1 ? 0 : noTraceJsn[recipeItemId],
          }
          submitParam.push(oneRow)
        }
      })
      dispatch(
        saveTraceCodesAsync({
          traceCodes: submitParam,
          treatmentId: treatmentId,
          isCheck: isCheck?.toString() || 1
        })
      )
        .then(unwrapResult)
        .then((v: any) => {
          if (isUpload) {
            if (baseData?.insuranceCode === 'ZHEJIANG') {
              drugUploadA('requestString', [paymentResult.id])
            } else {
              drugUpload('requestString', treatmentId,undefined,undefined,paymentId)
            }
          } else {
            onOk()
            setButtonLoading(false)
          }
        })
        .catch((v) => {
          const errorData = v?.message?.split('####')?.[1]
          const errDataMain = errorData ? JSON.parse(errorData) : {}
          if(v?.message.startsWith("追溯码校验异常") || v?.message.startsWith("追溯码重复采集")){
            Modal.confirm({
              title: '',
              icon: <ExclamationCircleOutlined />,
              okText: '确认无误',
              cancelText: '取消',
              content: (
                <div style={{fontWeight:'bold',marginTop:'-20px',fontSize:'16px'}}>
                  {errDataMain?.codeArray?.map((val:any,index?:any)=>{
                  return <div key={index}>{val}</div>
                  })}
                 <div>{errDataMain?.errMsg}</div>
                </div>
              ),
              onOk: (()=>{
                checkTraceCode(isUpload,0)
              }),
              onCancel: (()=>{
                setButtonLoading(false)
              })
            })
          }else{
            onCancel()
            setButtonLoading(false)
          }
        })
    }
  }

  // 发药单上传
  const drugUpload = (
    serverType: serverType,
    treatmentId: number | string,
    responseString?: string,
    recipeItemId?: string,
    paymentId?:number
  ) => {
    dispatch(
      drugUploadAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          treatmentId,
          shipmentState: 1,
          recipeItemId: recipeItemId || undefined,
          paymentId:paymentId
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          if (data?.isdone == '1') {
            notification.success({
              message: '上传完毕！',
            })
            return
          }
          const itemId = data.recipeItemId
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
                drugUpload(
                  'response',
                  treatmentId,
                  JSON.stringify(call.netmessage),
                  itemId,
                  paymentId,
                )
            }
          )
        } else {
          if (res.successCode === '1') {
            drugUpload('requestString', treatmentId,undefined,undefined,paymentId)
          } else {
            setButtonLoading(false)
            onOk()
          }
        }
      })
  }

  // 发药单批量上传
  const drugUploadA = (
    serverType: serverType,
    paymentIds: number[] | string[],
    responseString?: string,
    recipeId?: number
  ) => {
    dispatch(
      drugUploadAAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentIds,
          shipmentState: 1,
          recipeId: recipeId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          let data = null
          try {
            data = JSON.parse(res)
          } catch (e) {
            data = strParse(res)
          }
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '发药单上传',
            },
            (call: any, err) => {
              !err &&
                drugUploadA(
                  'response',
                  paymentIds,
                  JSON.stringify(call.netmessage),
                  recipeId
                )
              if (err) {
                setButtonLoading(false)
              }
            }
          )
        } else {
          setButtonLoading(false)
          onOk()
        }
      })
      .catch(() => setButtonLoading(false))
  }

  // 添加状态和函数用于批量复制
  const [copyVisible, setCopyVisible] = useState<{[key: string]: boolean}>({});

  // 处理批量复制功能
  const handleBatchCopy = (itemId: string, currentIndex: number, currentValue: string) => {
    const formValues = form.getFieldsValue();
    let totalCount = 0;
    if(grrkFlag){
      totalCount = items?.find((item:any) => (item?.id === itemId))?.count || 0;
    }else{
      totalCount = items?.find((item:any) => (item?.id === itemId))?.drugCount || 0;
    }
    // 创建新的 visible 状态对象
    const newVisibleState = {...copyVisible};

    for (let i = currentIndex + 1; i <= totalCount; i++) {
      const nextFieldName = `tradeCode_${itemId}_${i}`;

      // // 如果遇到有内容的框则停止
      // if (formValues[nextFieldName]) break;

      // 设置值
      form.setFieldsValue({
        [nextFieldName]: currentValue
      });

      // 更新 visible 状态
      newVisibleState[nextFieldName] = true;

      // 自动聚焦到下一个输入框
      const nextItemIndex = items.findIndex((item:any) => item.id === itemId);
      if (inputRefs.current[nextItemIndex] && inputRefs.current[nextItemIndex][i]) {
        inputRefs.current[nextItemIndex][i].focus();
      }
    }

    // 更新状态
    setCopyVisible(newVisibleState);
  };

// 在useEffect中更新copyVisible状态
  useEffect(() => {
    if (items) {
      const jsons: any = {};
      const visibleState: {[key: string]: boolean} = {};

      items?.map((item: any, itemIndex: number) => {
        [...Array(Math.ceil(grrkFlag ? item?.count : item?.drugCount))].map(
          (_, colIndex) => {
            const fieldName = 'tradeCode_' + item?.id + '_' + (Number(colIndex) + 1);
            if (item?.traceCodeList?.[colIndex]) {
              jsons[fieldName] = item?.traceCodeList?.[colIndex];
              visibleState[fieldName] = true;
            }
            noTraceJsn[item?.id] = item?.noTraceFlag;
            trdnFlagJsn[item?.id] = item?.trdnFlag;
            if (localStorage.getItem('trdnFlag_' + item?.localItemIdFake) === '1') {
              trdnFlagJsn[item?.id] = 1;
            }
          }
        );
      });

      setTrdnFlagJsn({...trdnFlagJsn});
      setNoTraceJsn({...noTraceJsn});
      console.log('noTraceJsn:' ,noTraceJsn)
      setCopyVisible(visibleState);
      if (jsons) {
        form.setFieldsValue({
          ...jsons,
        });
      }
    }
  }, [items]);

  const renderErrorMsg = (item:any, colIndex:number) => {
    const currentId = `tradeCode_Error_${item?.id}_${colIndex + 1}`;
    const matchedError = errorList.find((err:any) => err.id === currentId);

    if (matchedError && matchedError.cnt > 0) {
      return (
        <span style={{ color: "red" }}>
        提醒：该追溯码已在不拆零的情况下扫描过{matchedError.cnt}次
      </span>
      );
    }
    return null;
  };

  const sureSubmitOrsureButUploadSubmit = (flag:any) => {
    const filteredItems = items?.filter((item: any) => trdnFlagJsn[item?.id] <= 0 && noTraceJsn[item?.id] <= 0); //需要采集的数组
    const shouldBeCollected: any = sum(filteredItems?.map((val: any) => (grrkFlag ? val?.count : val?.drugCount))) //应采数量
    const collectedAlready
      = Object.entries(form.getFieldsValue())
        ?.filter(([key, value]: [string, any]) => {
          if (!value) return false;
          const id = key.split('_')[1];
          return filteredItems.some((item: any) => String(item.id) === id);
        })
        .map(([key, value]: [string, any]) => {
          return value
        })?.filter((val: any) => val) //实际采集的数量

    const remainingQuantity = shouldBeCollected - collectedAlready?.length //还剩多少没采集
    if (shouldBeCollected != collectedAlready?.length) {
      Modal.confirm({
        centered: true,
        title: "追溯码提醒",
        content: (
          <div>
            <ExclamationCircleFilled
              style={{ color: "#FFAE55", fontSize: 18 }}
            />
            &nbsp;追溯码采集总量必须等于发药数量，
            应采集{shouldBeCollected}，已采集{collectedAlready?.length}，还有{remainingQuantity}个未采集
          </div>
        ),
        okText: "仍要提交",
        cancelText: "继续采集",
        icon: null,
        onOk: () => {
          if (flag == 1) {
            sureSubmit()
          } else {
            sureButUploadSubmit()
          }
        },
      })
    } else {
      if (flag == 1) {
        sureSubmit()
      } else {
        sureButUploadSubmit()
      }
    }
  }


  const sureSubmit = () => {
    // form.validateFields().then((values) => {
      setButtonLoading(true)
      // saveTraceCodes(false)
      checkTraceCode(false)
    // }).catch((e) => {
    //   Modal.confirm({
    //     title: '提示',
    //     okText: '确认无误，继续',
    //     content: (
    //       <p>
    //         疑似存在重复扫描的整存追溯码，请确认。
    //       </p>
    //     ),
    //     onOk: () => {
    //       setButtonLoading(true)
    //       // saveTraceCodes(false)
    //       checkTraceCode(false)
    //     },
    //     onCancel: () => {
    //       setButtonLoading(false)
    //     }
    //   })
    //   // message.destroy()
    //   // messageApi.open({
    //   //   type: 'warning',
    //   //   content: '追溯码格式不正确，请重新输入。',
    //   //   className: 'custom-class',
    //   //   style: {
    //   //     marginTop: '35vh',
    //   //   },
    //   // })
    // })
  }

  const sureButUploadSubmit = () => {
    // form.validateFields().then((values) => {
      setButtonLoading(true)
      Modal.confirm({
        title: '',
        content: (
          <div>
            <ExclamationCircleFilled
              style={{ color: '#FFAE55', fontSize: 18 }}
            />
            &nbsp; 是否上传发药信息至医保？
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        icon: null,
        onOk: () => {
          // saveTraceCodes(true)
          checkTraceCode(true);
        },
        onCancel: () => {
          setButtonLoading(false)
        },
      })
    // }).catch((e) => {
    //   Modal.confirm({
    //     title: '提示',
    //     okText: '确认无误，继续',
    //     content: (
    //       <p>
    //         疑似存在重复扫描的整存追溯码，请确认。
    //       </p>
    //     ),
    //     onOk: () => {
    //       setButtonLoading(true)
    //       // saveTraceCodes(false)
    //       checkTraceCode(false)
    //     },
    //     onCancel: () => {
    //       setButtonLoading(false)
    //     }
    //   })
    //   // message.destroy()
    //   // messageApi.open({
    //   //   type: 'warning',
    //   //   content: '追溯码格式不正确，请重新输入。',
    //   //   className: 'custom-class',
    //   //   style: {
    //   //     marginTop: '35vh',
    //   //   },
    //   // })
    // })
  }
  return (
      <>
        {contextHolder}
    <div>
      <Modal
        width={700}
        title='电子追溯码录入'
        maskClosable={false}
        visible={showCodeInputModal}
        onCancel={() => {
          onCancel()
          form.resetFields()
          setTrdnFlagJsn({})
          setNoTraceJsn({})
          setButtonLoading(false)
        }}
        footer={
          <Row>
            <Col flex={1}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Checkbox
                    checked={hideNoTraceItems}
                    onChange={(e) => {
                      setHideNoTraceItems(e.target.checked)
                      localStorage.setItem('hideNoTraceItems-check', e.target.checked.toString())
                    }}
                    style={{ marginRight: '16px' }}
                  >
                    隐藏无码药品
                  </Checkbox>
                </div>
                <div>
                  {(grrkFlag && storehouseTag) ? (
                    <></>
                  ) : (
                    <Button
                      onClick={() => {
                        onCancel()
                        form.resetFields()
                        setTrdnFlagJsn({})
                        setNoTraceJsn({})
                        setButtonLoading(false)
                      }}
                    >
                      取消
                    </Button>
                  )}
                  {(storehouseTag || paymentResult?.state == 5 )? (
                    <></>
                  ) : (
                    <Button
                      type={'primary'}
                      loading={buttonLoading}
                      onClick={() => {
                        sureSubmitOrsureButUploadSubmit(1)
                      }}
                      style={{ marginLeft: '8px' }}
                    >
                      确认
                    </Button>
                  )}
                  {(showUploadBtn && paymentResult?.state ==3) ? (
                    <Button
                      type={'primary'}
                      disabled={!isShowUpload}
                      loading={buttonLoading}
                      onClick={() => {
                        sureSubmitOrsureButUploadSubmit(2)
                      }}
                      style={{ marginLeft: '8px' }}
                    >
                      确认并上传
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Col>
          </Row>
        }
        className={styles.traceCodeModal}
      >
        <Row className={styles.tips}>
          <Col span={24}>根据医保局最新的规定与要求：</Col>
          <Col span={24}>
            请在下方输入框中扫入每一盒药品包装上的电子追溯码。
          </Col>
          <Col span={24}>
            <span>包装</span>
            <span style={{ fontWeight: 'bold' }}>没有追溯码</span>
            <span>则不用扫入，系统会以</span>
            <span style={{ fontWeight: 'bold' }}>无码药品</span>
            <span>的方式上传。</span>
          </Col>
        </Row>

        {(!items?.length || items?.length == 0) && (
          <Row>
            <Col span={24} className={styles.errorMsg}>
              本次没有需要上传追溯码的药品。
            </Col>
          </Row>
        )}
        {items && items.length > 0 && (
          <>
            <Form
              onValuesChange={(changedValues, allValues) => {
                const newVisibleState = {...copyVisible};
                Object.entries(allValues).forEach(([key, value]) => {
                  newVisibleState[key] = !!value;
                });
                setCopyVisible(newVisibleState);
              }}
              form={form} autoComplete='off'>
              {items &&
                items
                  ?.filter((item: any) => {
                    // 如果勾选了"隐藏无码药品"，则过滤掉无码药品
                    if (hideNoTraceItems) {
                      return !(noTraceJsn[item?.id] == 1)
                    }
                    return true
                  })
                  ?.map((item: any, itemIndex: number) => {

                    const noTraceFlag = noTraceJsn[item?.id] == 0 || noTraceJsn[item?.id] == 1 ? noTraceJsn[item?.id] : item?.noTraceFlag
                  return (
                    <>
                      <Row key={itemIndex}>
                        <Col span={24} className={styles.traceNameCol}>
                          {item?.name}{' '}
                          {grrkFlag ? item?.count : item?.drugCount}
                          {item?.splitTag == 1
                            ? item?.splitUnit
                            : item?.accountUnit}{' '}
                          <span style={{color:'#333',fontWeight:'normal',marginRight:'6px'}}>{item?.packSpec}</span> {' '}
                          <span style={{color:'#333',fontWeight:'normal',marginRight:'6px'}}>{item?.batchNo?('  批号：'+item?.batchNo+' '):' '}</span>

                          {!grrkFlag && (
                            <>
                              <Checkbox
                                disabled={paymentResult?.state == 5}
                                defaultChecked={item?.trdnFlag == 1 ? true : localStorage.getItem('trdnFlag_' + item?.localItemIdFake) === '1'}
                                style={{marginLeft : 10}}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    localStorage.setItem('trdnFlag_' + item?.localItemIdFake,'1')
                                    trdnFlagJsn[item?.id] = 1
                                  } else {
                                    localStorage.removeItem('trdnFlag_' + item?.localItemIdFake)
                                    trdnFlagJsn[item?.id] = 0
                                  }
                                  setTrdnFlagJsn({...trdnFlagJsn})
                                }}
                              >
                                拆零
                              </Checkbox>
                              <Checkbox
                                disabled={paymentResult?.state == 5}
                                checked={noTraceFlag == 1 ? true : false}
                                style={{marginLeft : 10}}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    noTraceJsn[item?.id] = 1
                                  } else {
                                    noTraceJsn[item?.id] = 0
                                  }
                                  setNoTraceJsn({...noTraceJsn})
                                }}
                              >
                                无码药品
                              </Checkbox>
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        {[
                          ...Array(
                            Math.ceil(grrkFlag ? item?.count : item?.drugCount)
                          ),
                        ].map((_, colIndex) => {
                          const fieldName = `tradeCode_${item?.id}_${colIndex + 1}`;
                          return (
                            <React.Fragment key={colIndex}>
                              <Col span={24}>
                                <div style={{ display: "flex",lineHeight:"30px"}}>
                                  <Col span={19} className={styles.traceCodeCol} style={{display:"flex",lineHeight:"30px"}}>
                                    {colIndex + 1}.&nbsp;
                                    <Form.Item
                                      name={fieldName}
                                      validateTrigger={["onInput", "onBlur","onChange"]}
                                      help={form.getFieldError(fieldName)?.[0] || null} // 无错误时返回 null 不占位
                                      validateStatus={form.getFieldError(fieldName) ? "" : ""}
                                      style={{width:"100%",marginLeft:"5px","marginBottom":"0"}}
                                      rules={[
                                        {
                                          validator: (_, value) => {
                                            if (!value) return Promise.resolve();

                                            const allValues = form.getFieldsValue();
                                            const duplicates:any = [];

                                            Object.entries(allValues).forEach(([key, val]) => {
                                              if (key.startsWith('tradeCode_') && val === value && key !== fieldName ) {
                                                const match = key.match(/tradeCode_\d+_(\d+)/);
                                                if (match) {
                                                  duplicates.push(match[1]);
                                                }
                                              }
                                            });

                                            if (duplicates.length > 0 && trdnFlagJsn[item?.id] <= 0 && !grrkFlag) {
                                              return Promise.reject(new Error(`与第 ${duplicates.join(', ')} 行的追溯码重复`));
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <Input
                                        ref={(el) => {
                                          if (!inputRefs.current[itemIndex]) {
                                            inputRefs.current[itemIndex] = [];
                                          }
                                          inputRefs.current[itemIndex][colIndex] = el;
                                        }}
                                        disabled={paymentResult?.state == 5 || (grrkFlag && storehouseTag) || noTraceJsn[item?.id] == 1}
                                        className={styles.traceCodeInput}
                                        size="middle"
                                        placeholder={`${item?.name} 追溯码 ${colIndex + 1}`}
                                        allowClear
                                        onPressEnter={() => handlePressEnter(itemIndex, colIndex)}
                                        onInput={() => {
                                          // 触发当前及相邻字段的校验
                                          form.validateFields([
                                            fieldName,
                                            `tradeCode_${item?.id}_${colIndex}`,
                                            `tradeCode_${item?.id}_${colIndex + 2}`,
                                          ]);
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={5} className={styles.traceCodeCol}>
                                    {(copyVisible[fieldName] && ((grrkFlag && !storehouseTag) || (!grrkFlag && paymentResult?.state != 5))) && (
                                      <a
                                        style={{ marginLeft: "5px", fontSize: "12px" }}
                                        onClick={() => {
                                          const currentValue = form.getFieldValue(fieldName);
                                          handleBatchCopy(item?.id, colIndex, currentValue);
                                        }}
                                      >
                                        向下批量复制
                                      </a>
                                    )}
                                  </Col>
                                </div>
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </Row>

                    </>
                  )
                })}
            </Form>
          </>
        )}
      </Modal>
    </div>
      </>
  )
}
